// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"PQ","tooltipWrapper":"QQ","icon":"RQ","tooltip":"SQ","content":"TQ"};